import React from "react";
import styles from "./index.module.scss";
import { instagramUrl, patreonUrl, tgLink } from "../../constants";

const socialItems = [
  {
    title: "Telegram",
    subtitle: "Офіційний канал",
    icon: "telegram",
    url: tgLink,
    tone: "telegram",
  },
  {
    title: "Instagram",
    subtitle: "Новини та анонси",
    icon: "instagram",
    url: instagramUrl,
    tone: "instagram",
  },
  {
    title: "YouTube",
    subtitle: "Відеоінструкція",
    icon: "youtube",
    url: "https://www.youtube.com/watch?v=IStCDuTx2zg",
    tone: "youtube",
  },
  {
    title: "Фентезі Футбол",
    subtitle: "Твоя футбольна платформа",
    icon: "stars",
    url: "https://footbattle.click",
    tone: "ff",
  },
  {
    title: "Patreon",
    subtitle: "Підтримати проєкт",
    icon: "heart-fill",
    url: patreonUrl,
    tone: "patreon",
  },
];

const SocialNetworks = () => {
  const availableItems = socialItems.filter(({ url }) => Boolean(url));

  if (!availableItems.length) {
    return null;
  }

  return (
    <aside className={styles.social} aria-label="Соціальні мережі">
      <span className={styles.kicker}>Ми поруч</span>
      <div className={styles.links}>
        {availableItems.map(({ title, subtitle, icon, url, tone }) => (
          <a
            key={title}
            className={`${styles.link} ${styles[tone]}`}
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label={`${title}: ${subtitle}`}
          >
            <span className={styles.iconWrap} aria-hidden="true">
              <i className={`bi bi-${icon}`}></i>
            </span>
            <span className={styles.text}>
              <span className={styles.title}>{title}</span>
              <span className={styles.subtitle}>{subtitle}</span>
            </span>
          </a>
        ))}
      </div>
    </aside>
  );
};

export default SocialNetworks;
